import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { AnpReportData, AnpReportResponse } from "../types/anpReport.type";

type UseAnpReportType = ({ }: { id?: string; }) => UseQueryResult<AnpReportData, unknown>;

const useAnpReport: UseAnpReportType = ({ id }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<AnpReportResponse, unknown, AnpReportData>({
    enabled: !!id,
    queryKey: ['anpReport', id],
    queryFn: () => {
      return privateAxios.get(`/anp/reports/${id}`);
    },
    select: (data) => data?.data?.data,
  });
};

export default useAnpReport;
